import { render, staticRenderFns } from "./ProductionUnitMeasurementActivity.vue?vue&type=template&id=be8ca04e&scoped=true"
import script from "./ProductionUnitMeasurementActivity.vue?vue&type=script&lang=js"
export * from "./ProductionUnitMeasurementActivity.vue?vue&type=script&lang=js"
import style0 from "./ProductionUnitMeasurementActivity.vue?vue&type=style&index=0&id=be8ca04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8ca04e",
  null
  
)

export default component.exports